import { motion } from "framer-motion";
import { Star, BadgeCheck, Quote } from "lucide-react";
import { REVIEWS } from "@/data";

export default function Reviews() {
  return (
    <section
      id="reviews"
      className="py-24 sm:py-32 scroll-mt-20 bg-primary"
      data-testid="reviews-section"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="text-accent font-bold text-sm tracking-widest uppercase">
            Happy tails
          </span>
          <h2 className="font-display font-extrabold text-4xl sm:text-6xl mt-3 tracking-tight text-white">
            Loved by pups &amp; their humans
          </h2>
          <p className="text-white/70 mt-4 font-medium">
            A few kind words from our verified Mad Paws clients.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-7">
          {REVIEWS.map((r, i) => (
            <motion.article
              key={r.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`review-card-${i}`}
              className="relative flex flex-col rounded-3xl bg-card border border-white/5 shadow-[0_25px_60px_-25px_rgba(0,0,0,0.45)] overflow-hidden"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={r.photo}
                  alt={`Dog cared for by Cheeky Pups — reviewed by ${r.name}`}
                  loading="lazy"
                  data-testid={`review-photo-${i}`}
                  className="h-full w-full object-cover"
                  style={{ objectPosition: r.photoPosition }}
                />
                <span
                  className="absolute top-3 right-3 inline-flex items-center gap-1 text-[11px] font-semibold text-primary bg-white/95 backdrop-blur rounded-full px-2.5 py-1 shadow-sm"
                  title="Verified via Mad Paws"
                >
                  <BadgeCheck size={13} className="text-accent" />
                  Verified
                </span>
              </div>

              <div className="relative flex flex-col flex-1 p-7 sm:p-8">
                <Quote
                  aria-hidden
                  className="absolute top-5 right-5 text-secondary/70"
                  size={40}
                  strokeWidth={2}
                  fill="currentColor"
                />

                <div className="flex items-center gap-1 mb-4" aria-label={`${r.stars} out of 5 stars`}>
                  {Array.from({ length: r.stars }).map((_, idx) => (
                    <Star
                      key={idx}
                      size={18}
                      className="text-accent"
                      fill="currentColor"
                      strokeWidth={0}
                    />
                  ))}
                </div>

                <p
                  data-testid={`review-quote-${i}`}
                  className="text-primary/90 leading-relaxed font-medium flex-1"
                >
                  “{r.quote}”
                </p>

                <div className="mt-6 pt-5 border-t border-border">
                  <div className="font-display text-primary text-lg leading-tight" data-testid={`review-name-${i}`}>
                    {r.name}
                  </div>
                  <div className="text-xs text-muted-foreground font-medium">
                    {r.service} · {r.date}
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
